import $ from 'jquery';

/**
 * Change the sort value for the Listings Filter Search
 * and submit the form to update results
 */
$('.js-sort-option').on('click', function () {
    $('input#sort').val($(this).data('sort'));
    $('#listings-filter-form').trigger('submit');
});
